<script>
/**
 * tabnav组件，tab的header标签
 */
export default {
  name: "SjTabNav",
  props: {
    currentName: [String, Number],
    type: {
      type: String
    },
    size: {
      type: String
    },
    editable: {
      type: Boolean,
      default: false
    },
    panes: {
      type: Array,
      default() {
        return [];
      }
    },
    onTabClick: {
      type: Function,
      default() {
        return function() {};
      }
    },
    onCloseClick: {
      type: Function,
      default() {
        return function() {};
      }
    }
  },
  data() {
    return {
      alwaysShowClose: false
    };
  },
  /**
   * 取传入的panes的名称渲染标签
   * 样式由传入的type确定css class
   */
  render() {
    const {
      type,
      size,
      editable,
      panes,
      onTabClick,
      onCloseClick,
      alwaysShowClose
    } = this;

    const tabs = panes.map((pane, index) => {
      const tabName = pane.name || pane.index || index;
      pane.index = `${index}`;
      const tabLabelContent = pane.$slots.label || pane.label;
      const finalEditable = pane.self_editable || editable;
      return (
        <div
          ref="tabs"
          refInFor
          class={{
            "sj-tab-item": true,
            "is-active": pane.active,
            "is-editable": finalEditable,
            showClose: alwaysShowClose
          }}
          title={pane.label}
          on-click={ev => {
            onTabClick(pane, tabName, ev);
          }}
        >
          <div class="sj-tab-item-content">
            <div class="sj-tab-item-content-inner">{tabLabelContent}</div>
            {finalEditable ? (
              <SjIcon
                class="sj-tab-item-close"
                iconSize={8}
                theme="2"
                iconClass="commulti_close"
                nativeOnClick={ev => {
                  onCloseClick(tabName, index, ev);
                  ev.stopPropagation();
                }}
              ></SjIcon>
            ) : null}
          </div>
        </div>
      );
    });
    return (
      <div class={["sj-tab-nav-wrap"]}>
        <div
          class={{
            "sj-tab-nav": true,
            [`sj-tab-nav--${type}`]: true,
            [`sj-tab-nav--${type}-${size}`]: true
          }}
        >
          {tabs}
        </div>
      </div>
    );
  },
  methods: {},
  watch: {
    "panes.length": {
      immediate: true,
      handler(len) {
        if (len === 0) return;
        this.$nextTick(() => {
          const itemWidth = this.$refs.tabs[0].clientWidth;
          if (itemWidth >= 88) {
            this.alwaysShowClose = true;
          } else {
            this.alwaysShowClose = false;
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@--tab-border-color: @color-productlight;
@--tab-border-color-disabled: @color-gray-3;
@--tab-default-nav-wrap-line-color: @--tab-border-color;
@--tab-active-color: @color-highlight;

@--tab-header-border: @base-border-width @base-border-style @--tab-border-color;

@--tab-item-width-card: 100px;
@--tab-item-width-card-small: 70px;
@--tab-item-height-card: 40px;
@--tab-item-height-card-small: 30px;
@--tab-item-height-page: 50px;
@--tab-item-height-page-small: 40px;

@--tab-seperator-color-page: @color-available;

@--tab-border-radius-card: @base-border-radius @base-border-radius 0 0;

@--tab-background-color: @color-gray-2;
@--tab-background-color-active: @color-antibg;
@--tab-background-color-hover: @color-gray-2;

// chrome
@--tab-item-container-height-chrome: 40px;
@--tab-item-width-chrome: 112px;
@--tab-item-height-chrome: 36px;
@--tab-item-margin-top-chrome: 4px;
@--tab-item-border-radius: 6px;
@--tab-seperator-color-chrome: @color-light;
@--tab-header-item-chrome-background-color-active: @tab-header-item-chrome-background-color-active;
@--tab-header-item-chrome-background-color-hover: lighten(
  @tab-header-chrome-background-color,
  10%
);

.sj-tab-nav-wrap {
  position: relative;
  overflow: hidden;
  flex-shrink: 1 !important;
  flex-basis: 100%;

  .sj-tab-nav {
    position: relative;
    box-sizing: border-box;
    white-space: nowrap;
    transition: transform 0.3s;
    z-index: 2;

    .sj-tab-active-bar {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      background-color: @--tab-active-color;
      z-index: 1;
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      list-style: none;
    }

    .sj-tab-item {
      position: relative;
      cursor: pointer;
      box-sizing: border-box;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      list-style: none;
      .text("body", "normal");
    }
  }

  .sj-tab-nav--card {
    .sj-tab-item {
      border-radius: @--tab-border-radius-card;
      border: @--tab-header-border;
      margin-left: -1px;
      background-color: @--tab-background-color;
      // transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
      //   padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

      &:first-child {
        margin-left: 0;
      }

      &.is-active {
        .font_color("available");
        background-color: @--tab-background-color-active;
        border-bottom-color: @color-antibg;
      }
      &:hover {
        .font_color("highlight");
        border-top-color: @--tab-active-color;
        border-left-color: @--tab-active-color;
        background-color: @--tab-background-color-hover;
        border-right-color: @--tab-active-color;
        z-index: 2;
      }
    }
  }
  .sj-tab-nav--card-middle {
    .sj-tab-item {
      min-width: @--tab-item-width-card;
      padding: 0 10px;
      height: @--tab-item-height-card;
    }
  }
  .sj-tab-nav--card-small {
    .sj-tab-item {
      min-width: @--tab-item-width-card-small;
      padding: 0 10px;
      height: @--tab-item-height-card-small;
      .text("caption");
    }
  }

  .sj-tab-nav--page {
    width: 100%;
    display: flex;
    .sj-tab-item {
      flex-grow: 1;
      border-radius: @--tab-border-radius-card;

      &.is-active {
        color: @--tab-active-color;
      }

      &:hover {
        background-color: @color-gray-2;
      }

      &:first-child::after {
        content: none;
      }

      &::after {
        content: "";
        position: absolute;
        left: -0.5px;
        width: 1px;
        height: 22px;
        background-color: @--tab-seperator-color-page;
      }
    }
  }
  .sj-tab-nav--page-middle {
    .sj-tab-item {
      height: @--tab-item-height-page;
    }
  }
  .sj-tab-nav--page-small {
    .sj-tab-item {
      height: @--tab-item-height-page-small;
    }
  }

  .sj-tab-nav--chrome {
    display: flex;
    align-items: center;
    height: @--tab-item-container-height-chrome;
    overflow-y: hidden;
    overflow-x: auto;

    .sj-tab-item {
      width: @--tab-item-width-chrome;
      height: @--tab-item-height-chrome;
      border-radius: @--tab-item-border-radius @--tab-item-border-radius 0 0;
      margin-top: @--tab-item-margin-top-chrome;
      padding: 0 8px;
      box-sizing: border-box;
      min-width: 0;

      .sj-tab-item-content {
        overflow: hidden;

        .sj-tab-item-content-inner {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      &.is-editable {
        .sj-tab-item-content {
          width: 100%;
          display: flex;
          align-items: center;

          .sj-tab-item-content-inner {
            flex-grow: 1;
            flex-shrink: 0;
            text-align: left;
          }

          .sj-tab-item-close {
            flex-shrink: 0;
            display: none;
          }
        }
        min-width: 16px;

        &.showClose {
          .sj-tab-item-close {
            display: flex;
          }
          .sj-tab-item-content {
            .sj-tab-item-content-inner {
              flex-shrink: 1;
            }
          }
        }

        &.is-active {
          min-width: 36px;
          .sj-tab-item-close {
            display: flex;
          }
          .sj-tab-item-content {
            .sj-tab-item-content-inner {
              flex-shrink: 1;
            }
          }
        }
      }

      .sj-tab-item-corner(@cornerColor) {
        content: "";
        position: absolute;
        top: @--tab-item-height-chrome - @--tab-item-border-radius * 2;
        background-color: transparent;
        width: @--tab-item-border-radius * 2;
        height: @--tab-item-border-radius * 2;
        border-radius: 50%;
        box-shadow: @--tab-item-border-radius @--tab-item-border-radius 0 0
          @cornerColor;
      }

      &:hover:not(.is-active) {
        background-color: @--tab-header-item-chrome-background-color-hover;
        &:first-child::before,
        &::before {
          .sj-tab-item-corner(@--tab-header-item-chrome-background-color-hover);
          left: -@--tab-item-border-radius * 2;
          z-index: 2;
        }
        &::after {
          .sj-tab-item-corner(@--tab-header-item-chrome-background-color-hover);
          right: -@--tab-item-border-radius * 2;
          transform: rotate(90deg);
          z-index: 2;
        }
        & + .sj-tab-item:not(.is-active) {
          &::before {
            content: none;
          }
        }
      }

      &.is-active {
        background-color: @--tab-header-item-chrome-background-color-active;
        &:first-child::before,
        &::before {
          .sj-tab-item-corner(
            @--tab-header-item-chrome-background-color-active
          );
          left: -@--tab-item-border-radius * 2;
          z-index: 2;
        }
        &::after {
          .sj-tab-item-corner(
            @--tab-header-item-chrome-background-color-active
          );
          right: -@--tab-item-border-radius * 2;
          transform: rotate(90deg);
          z-index: 2;
        }
        & + .sj-tab-item {
          &::before {
            content: none;
          }
        }
      }

      &:first-child {
        margin-left: @--tab-item-border-radius * 2;
        &::before {
          content: none;
        }
      }

      &:last-child {
        margin-right: @--tab-item-border-radius * 2;
      }

      &::before {
        content: "";
        position: absolute;
        left: -0.5px;
        width: 1px;
        top: 8px;
        bottom: 8px;
        background-color: @--tab-seperator-color-chrome;
      }
    }
  }
}
</style>
